import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export function parseErrorMessage(_x) {
  return _parseErrorMessage.apply(this, arguments);
}
function _parseErrorMessage() {
  _parseErrorMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
    var json, text, errs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return response.text();
        case 2:
          text = _context.sent;
          _context.prev = 3;
          json = JSON.parse(text);
          _context.next = 10;
          break;
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](3);
          return _context.abrupt("return", text);
        case 10:
          delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
          if (!json.error) {
            _context.next = 15;
            break;
          }
          return _context.abrupt("return", "".concat(json.status || 'UNKNOWN_STATUS', " ").concat(json.error || 'MISSING_ERROR_MESSAGE'));
        case 15:
          if (!json.status) {
            _context.next = 19;
            break;
          }
          return _context.abrupt("return", "".concat(json.status, " MISSING_ERROR_MESSAGE"));
        case 19:
          if (!json.errors) {
            _context.next = 22;
            break;
          }
          errs = json.errors.map(function (error) {
            return typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE';
          });
          return _context.abrupt("return", errs.join('\n - '));
        case 22:
          return _context.abrupt("return", JSON.stringify(json));
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 7]]);
  }));
  return _parseErrorMessage.apply(this, arguments);
}